import { useMutation } from '@tanstack/vue-query'

export default () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async ({ subscriptionId, packageId }: { subscriptionId: string; packageId?: string }) =>
      await $fetch<string>('/api/payment-link/paypal/subscription', {
        method: 'POST',
        body: {
          subscriptionId,
          packageId,
        },
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
  })
}

